import { getData, postData } from '@core/utils/http/general'
import store from '@/store'

//* Obtener lista de documentos obligatorios por plan de estudios
export const getDocumentTypesForPlan = q => new Promise((resolve, reject) => {
  getData({ action: 36, q })
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Obtener lista de documentos cargados
export const getDocumentTypes = () => new Promise((resolve, reject) => {
  getData({ action: 33 })
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Obtener lista de documentos cargados
export const uploadedDocuments = (params, ws = undefined) => new Promise((resolve, reject) => {
  getData(params, ws)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Asigna un archivo como documentación de una persona
export const assignAsPersonalDocument = dataParam => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('origin', process.env.VUE_APP_ORIGIN_API)

  Object.entries(dataParam).forEach(element => { data.append(element[0], element[1]) })

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Autorizar o rechazar documentación de usuario
export const authorizeOrRefuseDocument = dataParam => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('action', 3)
  data.append('task', 'wsdocumentos')
  data.append('token', store.state.cuenta.session.token)
  data.append('origin', process.env.VUE_APP_ORIGIN_API)

  Object.entries(dataParam).forEach(element => { data.append(element[0], element[1]) })

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
